var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-scale-complex"},_vm._l((_vm.threshold),function(number){return _c('div',{key:number,staticClass:"scale-part",style:({
      width: ("calc(" + (100 / _vm.threshold) + "% - 3px)")
    })},[_c('line-scale',{attrs:{"value":_vm.getValuePart(number),"color-thumb":_vm.colorThumb}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }